const ServiceList = [

    { name: "Diagnostic Services", path: "DiagnosticServices" },
     { name: "B2B", path: "B2B" },
    { name: "Pulmonology", path: "pulmonology" },
    {
        name: "Radiology",
        path: "radiology",
        children: [
            {name: "Xray", path: "xray"},
            { name: "BMD", path: "bmd" },
            { name: "Digital Mammography", path: "mamography" }
        ]
    },
    { name: "Cardiology", path: "cardiology" },
    { name: "Gastroenterology", path: "gastroenterology" },
    { name: "Dialysis", path: "dialysis" },
    { name: "Physiotherapy", path: "physiotherapy" },
    { name: "Ophthalmology", path: "ophthalmology" },
    { name: "Dental", path: "dental" },
    { name: "Dermatology", path: "dermatology" },
    { name: "Neurology", path: "neurology" },
    { name: "home care", path: "homecares" },

    // { name: "Homecare", path: "homecare" },
    { name: "Pathology", path: "pathology" },
    { name: "Urology", path: "urology" },
    { name: "Portable Services", path: "portable" },
]

export default ServiceList;